export const DEFAULT_RICH_TEXT_CONFIG = {
  placeholder: '请输入内容',
  markdown: { // markdown配置
    h1: true, // 一级标题
    h2: true, // 二级标题
    bold: true, // 加粗
    italic: true, // 斜体
    ol: true, // 有序列表
    ul: true, // 无序列表
  },
  lineBreak: true, // 是否支持换行
  breakWay: 'enter', // 换行方式, enter: 回车换行, shiftEnter: shift+回车换行
  emoji: true, // 允许插入emoji
  link: true, // 允许插入链接
  image: true, // 允许插入图片
  at: true, // 允许艾特, 输入@时触发
  atTypes: ['room'], // 艾特类型 room: 房间, role: 权限组, friend: 好友
  channel: true, // 允许插入频道, 输入#时触发
  autoFocus: false, // 是否自动聚焦
  userCard: true, // 是否支持点击艾特用户弹出用户卡片
  botCommand: false, // 是否支持bot命令
}

export const INPUT_ACCEPT_IMGAGE = "image/gif,image/jpeg,image/jpg,image/png,image/webp"

export const INPUT_ACCEPT_VIDEO = "video/*"